import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import SharedAccountsList from "../../features/sharedAccount/sharedAccountsList";
import {
  useLazyGetFamilyQuery,
  useUnlinkFamilyMutation,
} from "../../services/sharedAccount";
import IfCan from "../../components/IfCan";
import { toast } from "react-toastify";

const ManageSharedAccount = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [getSharedAcc] = useLazyGetFamilyQuery();
  const [unlink] = useUnlinkFamilyMutation();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [isReload, setIsReload] = useState(Date.now());

  useEffect(() => {
    const delay = 1000; // Debounce delay in milliseconds
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm && setDebouncedSearchTerm(searchTerm);
    }, delay);

    return () => {
      clearTimeout(timerId); // Clear the timeout on cleanup
    };
  }, [searchTerm]);

  const getSharedAccountList = async () => {
    setIsLoading(true);
    try {
      const response = await getSharedAcc({
        search: debouncedSearchTerm,
        start: page,
        length: 10,
      }).unwrap();

      if (response?.status === 200) {
        setData(response?.data || []);
        setTotalCount(response?.data?.length || 0);
      } else {
        setData([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.log(error);
      setData([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getSharedAccountList();
  }, [debouncedSearchTerm, page, isReload]);

  const handleForceUnlink = async (id: number) => {
      try {
        const response = await unlink({ id }).unwrap();
        if (response?.status === 200) {
          toast.success("Family unlinked successfully");
          getSharedAccountList();
        }
      } catch (error) {
        console.log(error);
        toast.error("Error unlinking family");
      }
    };
  return (
    <>
      <IfCan module="Shared Account" action="view">
        <div className="main_title">
          <h1>Family / Shared Account Manager</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Family / Shared Account Manager
          </p>
        </div>

        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
                onChange={(val: any) => {
                  setSearchTerm(val.target.value);
                }}
              />
            </div>
          </div>
          <SharedAccountsList
            data={data}
            isLoading={isLoading}
            unlink={(id:number) => handleForceUnlink(id)}
          />
        </div>
      </IfCan>
    </>
  );
};

export default ManageSharedAccount;
